import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const useStyles = makeStyles(theme => {
  const { right, paddingLR, left, marginLR } = theme.mixins;

  return {
    filterSection: {
      paddingBottom: theme.spacing(9),
      [theme.breakpoints.up('lg')]: {
        background: theme.mixins.LightOrange(),
        paddingBottom: '0',
      },
    },
    drawerWrapper: {
      width: '100%',
    },
    filterMobileContainer: {
      width: '100%',

      '& .MuiPaper-root': {
        width: '100%',
      },
    },
    heading: {
      color: theme.mixins.neroBlack(700),
    },
    togglefilterButton: {
      position: 'fixed',
      bottom: pxToRem(16),
      ...right(pxToRem(24)),
      zIndex: 100,

      '& button': {
        padding: `${pxToRem(8)} ${pxToRem(25)}`,
        '@media (max-width: 414px)': {
          ...theme.mixins.paddingRight(pxToRem(21)),
          ...theme.mixins.paddingLeft(pxToRem(14)),
        },
        '@media (max-width: 374px)': {
          fontSize: fontSize.s0Rem,
          lineHeight: fontSize.s0Rem,
          color: 'transparent',
          ...theme.mixins.paddingRight(pxToRem(14)),
          ...theme.mixins.paddingLeft(pxToRem(14)),
        },
        ...theme.typography.body2Bold,
        color: theme.mixins.White(),

        '& .MuiButton-startIcon': {
          ...theme.mixins.marginLeft(pxToRem(0)),
          '@media (max-width: 374px)': {
            ...theme.mixins.marginRight(pxToRem(0)),
          },
        },
      },
    },
    crossIcon: {
      marginLeft: 10,
    },
    container: {
      padding: pxToRem(23),

      '& svg': {
        position: 'absolute',
        top: pxToRem(21),
        ...right(pxToRem(24)),
      },
      '& .MuiFormControlLabel-label': {
        color: theme.palette.text.tertiary,
      },
      '& .MuiFormControl-root': {
        margin: 0,
        width: '100%',
        '& .MuiFormLabel-root': {
          marginBottom: pxToRem(16),

          '&.MuiInputLabel-root': {
            position: 'relative',
            marginBottom: 0,
            top: pxToRem(0),
            [theme.breakpoints.up('lg')]: {
              top: pxToRem(0),
            },
          },
        },
        '& .MuiInputBase-root': {
          marginTop: 0,
        },
        '& .MuiFormGroup-root': {
          '&[role=radiogroup]': {
            flexDirection: 'column',

            '& .MuiFormControlLabel-root': {
              marginBottom: pxToRem(16),
              '& .MuiFormControlLabel-label': {
                marginLeft: 0,
              },
            },
          },
          '& .MuiFormControlLabel-root': {
            marginBottom: pxToRem(16),
            '& .MuiFormControlLabel-label': {
              marginLeft: 0,
            },
          },
          '& .MuiButtonBase-root.MuiRadio-root': {
            padding: 0,
            marginLeft: 11,
          },
          '& .MuiButtonBase-root.MuiRadio-root +  .MuiTypography-root': {
            paddingLeft: 8,
          },
        },
      },
      '&:not(:last-child)': {
        borderBottom: `1px solid ${theme.palette.border.divider}`,
      },
      '&:first-child': {
        textAlign: 'center',
        [theme.breakpoints.up('lg')]: {
          textAlign: 'initial',
          display: 'flex',
          justifyContent: 'space-between',
          color: theme.mixins.neroBlack(700),
        },
      },
    },
    eventColor: {
      '& .MuiFormGroup-root .more': {
        color: theme.mixins.DarkTurquoise(),
        '&::after': {
          borderColor: theme.mixins.DarkTurquoise(),
        },
      },
      '& .MuiFormGroup-root .less': {
        color: theme.mixins.DarkTurquoise(),
        '&::after': {
          borderColor: theme.mixins.DarkTurquoise(),
        },
      },
      '& .MuiCheckbox-root input:hover ~ span': {
        borderColor: theme.mixins.DarkTurquoise(),
      },
      '& .checkedIcon': {
        borderColor: theme.mixins.DarkTurquoise(),
        background: theme.mixins.DarkTurquoise(),
      },
    },
    eventBtnColor: {
      backgroundColor: theme.mixins.DarkTurquoise(),
    },
    dropdown: {
      padding: `${pxToRem(40)} ${pxToRem(23)}`,

      '& .MuiInputBase-root': {
        '&:hover, &:focus': {
          background: theme.palette.action.disabledBackground,
        },
        '& .MuiSelect-root': {
          '&:hover, &:focus': {
            background: 'transparent',
          },
        },
      },
    },
    mobileFooter: {
      display: 'flex',
      position: 'fixed',
      width: '100%',
      bottom: '0',
      left: '0',
      height: pxToRem(72),
      background: theme.palette.common.NearWhite,
      justifyContent: 'space-between',
      alignItems: 'center',
      ...paddingLR(pxToRem(24), pxToRem(24)),

      '& button': {
        padding: `${pxToRem(8)} ${pxToRem(25)}`,
        ...theme.typography.body2Bold,
        color: theme.mixins.White(),

        '& .MuiButton-label': {
          '& .MuiButton-endIcon': {
            marginLeft: 8,
          },
        },
      },
    },
    priceRangeText: {
      color: theme.mixins.Black(600),
    },
    resetButton: {
      position: 'absolute',
      top: pxToRem(25),
      ...left(pxToRem(24)),
    },
    filterText: {
      fontFamily: theme.custom.fontFamily.primaryBold,
      color: theme.mixins.RussianViolet(),
    },
    viewAllMobileBtn: {
      position: 'fixed',
      bottom: pxToRem(16),
      ...left(pxToRem(24)),
      zIndex: 100,

      '& button': {
        backgroundColor: theme.mixins.Black(1000),
      },
    },
    viewAllBtnEndIcon: {
      ...theme.mixins.marginLeft(pxToRem(8)),
    },
    desktopViewAllSection: {
      backgroundColor: theme.mixins.LightOrange(),
      marginBottom: pxToRem(24),
      padding: pxToRem(24),
      color: theme.mixins.RussianViolet(),
    },
    listingText: {
      display: 'flex',
      alignItems: 'baseline',
      marginBottom: pxToRem(20),

      '& p': {
        ...marginLR(pxToRem(3), 0),
      },
    },
  };
});

export default useStyles;
